import { render, staticRenderFns } from "./sqlAudit.vue?vue&type=template&id=4c532fa3&scoped=true&"
import script from "./sqlAudit.vue?vue&type=script&lang=js&"
export * from "./sqlAudit.vue?vue&type=script&lang=js&"
import style0 from "./sqlAudit.vue?vue&type=style&index=0&id=4c532fa3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c532fa3",
  null
  
)

export default component.exports